export var MuiTableContainerOverrides = {
  styleOverrides: {
    root: {
      borderRadius: '0.5rem'
    }
  }
};